import { Link } from 'react-router-dom';
import { Facebook, Instagram, Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-amber-50 to-white border-t border-amber-100 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold text-primary mb-4">HHouse of Breadss</h3>
            <p className="text-muted-foreground mb-4">
              Fresh & Eggless bakery delights. Celebrate your special occasions with our delicious products.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=100063631674869" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-primary transition-colors" data-testid="facebook-link">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/hhouse_of_breadss" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-primary transition-colors" data-testid="instagram-link">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-accent mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-muted-foreground hover:text-primary transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/products?category=breads" className="text-muted-foreground hover:text-primary transition-colors">
                  Breads
                </Link>
              </li>
              <li>
                <Link to="/products?category=cakes" className="text-muted-foreground hover:text-primary transition-colors">
                  Cakes
                </Link>
              </li>
              <li>
                <Link to="/products?category=cookies" className="text-muted-foreground hover:text-primary transition-colors">
                  Cookies
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-accent mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-muted-foreground">
                <MapPin className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <span>R3/015A, M3M Cosmopolitan, Sec 66, Gurugram, Haryana</span>
              </li>
              <li className="flex items-center space-x-2 text-muted-foreground">
                <Phone className="h-5 w-5" />
                <a href="tel:+919999183418" className="hover:text-primary transition-colors">+91-9999183418</a>
              </li>
              <li className="flex items-center space-x-2 text-muted-foreground">
                <Mail className="h-5 w-5" />
                <a href="mailto:hhouseofbreadss@gmail.com" className="hover:text-primary transition-colors">hhouseofbreadss@gmail.com</a>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-sm text-muted-foreground">Mon - Sat: 9:00 AM – 6:00 PM</p>
              <p className="text-sm text-muted-foreground">Sunday: Closed</p>
            </div>
          </div>
        </div>

        <div className="border-t border-amber-100 mt-8 pt-8 text-center">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-1 mb-3 text-sm">
            <Link to="/privacy-policy" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-privacy-policy">
              Privacy Policy
            </Link>
            <Link to="/refund-policy" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-refund-policy">
              Refund & Cancellations
            </Link>
            <Link to="/terms-and-conditions" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-terms-conditions">
              Terms & Conditions
            </Link>
          </div>
          <p className="text-sm text-muted-foreground">&copy; 2025 HHouse of Breadss. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
